export type FeedbackTrigger = 1 | 3 | 5 | 7 | 9;

export const FEEDBACK_TRIGGERS: FeedbackTrigger[] = [1, 3, 5, 7, 9];

export interface FeedbackAnswer {
  id: string;
  answer: string;
  order: number;
  // Only the get-by-id endpoint counts these; the list always returns 0
  totalAnswered: number;
}

export interface Feedback {
  id: string;
  title: string;
  question: string;
  numberOfFinishedLessonTrigger: FeedbackTrigger;
  dateCreated: string;
  answers: FeedbackAnswer[];
}

export interface CreateFeedbackPayload {
  title: string;
  question: string;
  numberOfFinishedLessonTrigger: FeedbackTrigger;
  answers: string[];
}
